export default __webpack_public_path__ + "static/media/city-profile.4d64bba9.jpg";